// extracted by mini-css-extract-plugin
export default {"toast_mui":"toastMui_toast_mui__JMbt5","close":"toastMui_close__feQ78"};